import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// NOTE : l'ancien monkeypatch removeChild/insertBefore (workaround React #11538 contre la
// traduction automatique) a été RETIRÉ car il désynchronisait React et faisait planter le
// remplissage auto de carte sur Safari (page blanche à l'étape paiement).
// À la place : (1) la traduction est bloquée à la source via translate="no" + <meta notranslate>
// dans public/index.html ; (2) un ErrorBoundary attrape proprement tout plantage résiduel
// (extension/logiciel bancaire) sans démonter toute la page.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
